// extracted by css-extract-rspack-plugin
export default {"container":"amberSalesBanner-module__container","mapViewStyles":"amberSalesBanner-module__mapViewStyles"};